import { useDispatch } from 'react-redux';
import { setUnitValue, setUnitValueByPath } from 'store/units/reducer';
import { editUnitInfo } from 'store/units/sagaActions';
import type { UnitInfoInterface } from 'store/units/types';

export const useEditUnitInfo = <T extends UnitInfoInterface>(
  unitKey: string,
  unitInfo: T,
) => {
  const dispatch = useDispatch();

  const setValue = <U extends keyof T>(
    key: U | [U, keyof T[U]],
    value: T[U] | T[U][keyof T[U]],
  ) => {
    if (Array.isArray(key)) {
      dispatch(setUnitValueByPath(unitKey, key, value));
    } else {
      if (unitInfo[key] !== value) {
        dispatch(setUnitValue<T>(unitKey, key, value as T[U]));
      }
    }
  };

  const setValues = (values: Partial<T>) => {
    dispatch(editUnitInfo(unitKey, { ...unitInfo, ...values }));
  };

  return { setValue, setValues };
};
